import { ContainerComponent, wrap } from 'AppReact';
import { BorderedImage, SecondaryTextXs } from 'atoms';
import { ElementWithPopupWrapper, PopupWrapper } from 'wrappers';
import internalState from './internalState';

export const definition = {
  name: 'ReportsImagePopup',
  controller: {},
  initialProps: ({ attachments, index, length }) => ({ attachments, index, length }),
  props: internalState,
  elements: [
    {
      component: BorderedImage,
      name: 'Image',
      renderIf: ({ attachments }) => attachments?.length > 0 && attachments.find(a => a.content_type.includes('image')),
      displayValue: ({ attachments }) => attachments.find(a => a.content_type.includes('image')).url,
      displayState: ({ }) => ({ width: '28px', height: '28px' })
    },
    {
      component: SecondaryTextXs,
      name: 'No image',
      renderIf: ({ attachments }) => !attachments || attachments.length === 0,
      displayValue: ({ }) => 'No image'
    },
    {
      wrapper: PopupWrapper,
      name: 'PopupWrapper',
      renderIf: ({ attachments }) => attachments?.length > 0 && attachments.find(a => a.content_type.includes('image')),
      displayState: ({ index, length }) => ({ position: index < 4 ? 'left-bottom' : index > length - 4 ? 'left-top' : 'left' }),
      elements: [
        {
          component: BorderedImage,
          name: 'Image',
          displayValue: ({ attachments }) => attachments.find(a => a.content_type.includes('image')).url,
          displayState: ({ }) => ({ width: '200px', height: '200px' })
        },
      ]
    }
  ]
}

export default wrap(ContainerComponent(definition), ElementWithPopupWrapper);